import DOMPurify from "dompurify";

// Centralized HTML sanitizer for everything that goes into
// `dangerouslySetInnerHTML`. Even though content typically originates from our
// own backend, sanitizing at the edge guards against admin compromise, copy-
// paste mistakes in translations, and future content sources.
export const sanitizeHtml = (html: string): string => DOMPurify.sanitize(html);
